// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__2AZgk","warningModal":"Section_warningModal__2yAaE"};